<template>
  <div v-if="protocol && protocol.budget" class="p-grid p-col-12">
      <card v-if="protocol.status === 'CANCELED'" class="p-col-12 content">
          <h1 class="p-col-12">{{ $t('protocol.tab-checklist.budget-checklist.canceled-warning') }}</h1>
          <template v-if="loggedUser.typeUser !== limited">
            <h2 class="p-col-12">{{ $t('protocol.tab-checklist.budget-checklist.reactive') }}</h2>
            <Button class="p-button-outlined p-button-warning p-mr-2 p-mb-2 p-button p-component" @click.prevent="reactive" v-if="protocol.status !== 'ACTIVE'">
            <span class="p-button-label">
              <i class="fas fa-check p-mr-2"></i>{{$t('protocol.tab-general.actions.reactive')}}
            </span>
              </Button>
          </template>
      </card>
      <card v-else class="p-col-12 content">
          <h1 class="p-col-12">{{ $t('protocol.tab-checklist.budget-checklist.only-protocol') }}</h1>
          <h4 class="p-col-12">{{ $t('protocol.tab-checklist.budget-checklist.protocol-tip-to-enable') }}</h4>
          <Button class="p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="budgetToProtocol" v-if="loggedUser.typeUser !== limited">
            <span class="p-button-label">
              <i class="fas fa-file-contract p-mr-2"></i>{{$t('protocol.tab-general.actions.protocol')}}
            </span>
          </Button>
      </card>
  </div>
  <div v-else class="p-grid p-col-12">
    <card class="p-col-12 content" v-if="!loadingPage">
      <h1 class="p-col-12" v-if="checklistProtocolPerson.length === 0">{{ $t('protocol.tab-checklist.no-checklist') }}</h1>
      <div class="p-col-12" v-else>
        <div class="p-col-12">Checklist status: <ancestryline-progress-bar :value="protocolProgress" /></div>
      </div>
      <checklist-protocol-person v-for="(checklist, index) in checklistProtocolPerson"
        :key="index"
        :protocolId="protocolId" 
        :sent="protocol.sent" 
        :checklist="checklist" 
        :clientsErrors="clientsErrors"
        :clientsProtocol="clientsProtocol"
        :checklistProtocolPerson="checklistProtocolPerson"
        :level="1" />
    </card>

    <div class="footer">
      <div class="p-col-12 p-text-right" style="padding-top: 0.35rem;">
        <Button v-if="protocol && !protocol.sent" class="p-button-outlined p-mr-2 p-button p-component" @click.prevent="sendProcess" :disabled="protocolProgress < 100">
          <span class="p-button-label">
            <i class="fa-classic fa-solid fa-paper-plane"></i>  {{$t('protocol.tab-checklist.send-process')}}
          </span>
        </Button>
        <Button v-if="protocol && protocol.sent" class="p-button-outlined p-button-danger p-mr-2 p-button p-component" @click.prevent="cancelSendProcess">
          <span class="p-button-label">
            <i class="fa-classic fa-solid fa-paper-plane"></i>  {{$t('protocol.tab-checklist.cancel-send-process')}}
          </span>
        </Button>
        <Button v-if="protocol" class="p-button-outlined p-mr-2 p-button p-component" @click.prevent="generateGenealogyTreeDocx">
          <span class="p-button-label">
            <i class="fa-solid fa-folder-tree"></i>  {{$t('protocol.tab-checklist.print-tree')}}
          </span>
        </Button>
        <Button v-if="protocol" class="p-button-outlined p-mr-2 p-button p-component" @click.prevent="getHtmlLetter">
          <span class="p-button-label">
            <i class="fa-solid fa-envelope-open-text"></i>   {{$t('protocol.tab-checklist.print-letter')}}
          </span>
        </Button>
        <Button v-if="protocol && !protocol.sent" :label="$t('protocol.tab-checklist.add-person-checklist')" @click.prevent="openModalAddChecklistProtocolPerson" class="p-mr-2"/>
        <Button v-if="protocol && !protocol.sent" :label="$t('btn.save&continue')" @click.prevent="save" class="p-mr-2 p-button-success"/>
      </div>
    </div>
  </div>
</template>

<script>

import CertificateProtocolBusiness from "@/business/CertificateProtocolBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import EventBus from "@/commons/EventBus";
import DialogService from "@/business/ModalBusiness";
import ModalAddCertificate from "@/viewer/protocol/tabs/checklist/ModalAddCertificate";
import ChecklistProtocolPerson from "@/viewer/protocol/tabs/checklist/ChecklistProtocolPerson";
import {APPLICANT, ASCENDANT, IMMIGRANT} from "@/constants/CategoryOfCertificates";
import store from "@/store";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import LetterBusiness from "@/business/LetterBusiness";
import TreeBusiness from "@/business/TreeBusiness";
import ChecklistProtocolPersonBusiness from "@/business/ChecklistProtocolPersonBusiness";
import ModalSendProcess from "@/viewer/protocol/tabs/checklist/ModalSendProcess.vue";
import ModalEditLetter from "@/viewer/protocol/tabs/checklist/ModalEditLetter.vue";
import {LIMITED} from "@/constants/TypeUser";

export default {
  name: "TabChecklistProtocol",
  components: {ChecklistProtocolPerson},

  async mounted() {
    this.loadParams();
    this.protocol = await ProtocolBusiness.getById(this.protocolId);
    await this.loadClientsProtocol();
    await this.loadChecklistProtocolPeople();
    this.onDeleteCertificate();
    EventBus.$on('openModalAddChecklistProtocolPerson', this.openModalAddChecklistProtocolPerson);
    EventBus.$on('loadChecklistProtocolPeople', this.loadChecklistProtocolPeople);
  },

  data() {
    return{
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
      checklistProtocolPerson: [],
      mapClientsProtocolAndChecklist: {},
      protocolId: null,
      protocol: null,
      clientsProtocol: [],
      immigrantsAscendantsCategories: [ASCENDANT, IMMIGRANT],
      generalMessages: [],
      clientsErrors: [],
      loadingPage: true,
    }
  },

  computed:{
    protocolProgress() {
      return this.calculateProgressCertificates(this.getAllCertificates(this.checklistProtocolPerson[0]));
    }
  },

  methods:{

    calculateProgressCertificates: CertificateProtocolBusiness.calculateProgressCertificates,
    getAllCertificates: CertificateProtocolBusiness.getAllCertificates,

    loadParams(){
      this.protocolId = this.$route.params.id;
    },

    async loadClientsProtocol(){
      this.clientsProtocol = await ProtocolBusiness.clientsOfProtocol(this.protocolId);
    },

    async loadChecklistProtocolPeople(){
      this.loadingPage = true;
      EventBus.loadingModal(true);
      try {
        let checklistProtocolPerson = await ChecklistProtocolPersonBusiness.getByProtocolId(this.protocolId);
        await this.$set(this, 'checklistProtocolPerson', checklistProtocolPerson);
        await this.loadPersonsMissingInChecklist();
        await this.loadErrorsValidation();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
          this.loadingPage = false;
          EventBus.loadingModal(false);
      }
    },

    async loadPersonsMissingInChecklist(){
        let mapClientsProtocolAndChecklist = await ChecklistProtocolPersonBusiness.getPersonsMissingInChecklist(this.protocolId);
        this.$set(this, 'mapClientsProtocolAndChecklist', mapClientsProtocolAndChecklist);
        await this.loadGeneralErrors();
    },

    async loadErrorsValidation() {
        const response = await LetterBusiness.getErrorsValidation(this.protocolId).catch((e) => ToastMessageBusiness.showError(e.message));
        if (response) {
            this.clientsErrors = response.clientErrorsDTO;
        }
    },

    createEmptyChecklistProtocolPerson(checklist){
      return {
        person: checklist.person,
        parent: checklist.parent,
        protocol: checklist.protocol,
        category: checklist.category || APPLICANT,
        certificates: checklist.certificates || [],
      }
    },

    async save(){
      const response = await ChecklistProtocolPersonBusiness.save(this.protocolId, this.checklistProtocolPerson).catch(async (e) => {
        if (e.message === 'error.concurrent-edit') {
          ToastMessageBusiness.showError(this.$t('error.concurrent-edit'));
          await this.loadChecklistProtocolPeople();
        } else {
          ToastMessageBusiness.showError(e.message);
        }
      });
      if(response){
        await this.loadChecklistProtocolPeople();
        ToastMessageBusiness.showSuccess();
      }
    },

    async deleteChecklistProtocolPerson(checklistProtocolPerson){
        if(await DialogService.openConfirmationModal(AncestrylineConfirmation, {message: "protocol.tab-checklist.confirm-delete-checklist-person"})){
            const response = await ChecklistProtocolPersonBusiness.delete(checklistProtocolPerson.id).catch((e) => {
                if(e.checklist_protocol_person_constraint){
                    ToastMessageBusiness.showError(e.checklist_protocol_person_constraint)
                } else {
                    ToastMessageBusiness.showError(e.message)
                }
            });
            if(response){
                window.location.reload();
            }
        }
    },

    onDeleteCertificate(){
      EventBus.$on('DELETE_CERTIFICATE', async (certificate) => {
        if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
            if(certificate.id) {
                const response = await CertificateProtocolBusiness.delete(certificate.id).catch((e) => ToastMessageBusiness.showError(e.message));
                if(response){
                    await this.loadChecklistProtocolPeople();
                    ToastMessageBusiness.showSuccess();
                }
            } else {
                await this.loadChecklistProtocolPeople();
                ToastMessageBusiness.showSuccess();
            }
        }
      });
    },

    async openModalAddChecklistProtocolPerson(checklistPersonToEdit){
      const modalProps = {clientsProtocol: this.clientsProtocol, checklists: this.checklistProtocolPerson, checklistPersonToEdit: checklistPersonToEdit};
      const newChecklistCertificate = await DialogService.openModal(ModalAddCertificate, modalProps);
      if(newChecklistCertificate){
        if(newChecklistCertificate.category === IMMIGRANT && this.checklistProtocolPerson.filter(cpp => cpp.category === IMMIGRANT).length > 0){
            ToastMessageBusiness.showError(this.$t('protocol.tab-checklist.error-multiple-immigrant'));
        } else {
            const newParent = newChecklistCertificate.parent ? {id: newChecklistCertificate.parent} : null;
            const emptyChecklistProtocolPerson = this.createEmptyChecklistProtocolPerson({ person: newChecklistCertificate.client, protocol: {id: this.protocolId}, category: newChecklistCertificate.category, parent: newParent});
            if (checklistPersonToEdit.id) {
                emptyChecklistProtocolPerson.id = checklistPersonToEdit.id;
            }
            if (checklistPersonToEdit.checklistOrder) {
                emptyChecklistProtocolPerson.checklistOrder = checklistPersonToEdit.checklistOrder;
            }
            const response = await ChecklistProtocolPersonBusiness.saveOne(emptyChecklistProtocolPerson).catch((e) => ToastMessageBusiness.showError(e.message));
            if(response){
                await this.loadChecklistProtocolPeople();
                await this.save();
            }
        }
      }
    },

    async loadGeneralErrors(){
        /*const clientsMissingProtocol = this.mapClientsProtocolAndChecklist.clientsChecklist.filter(clientCheck => !this.mapClientsProtocolAndChecklist.clientsProtocol.some(clientProtocol => clientProtocol.name === clientCheck.name));
        const clientsMissingProtocolID = "clientsMissingProtocolWarningID";
        const clientsMissingProtocolTitleKey = 'protocol.tab-checklist.messages.clients-missing-services';
        this.loadClientsMissingWarning(clientsMissingProtocol, clientsMissingProtocolID, clientsMissingProtocolTitleKey)

        const clientsMissingChecklist = this.mapClientsProtocolAndChecklist.clientsProtocol.filter(clientProtocol => !this.mapClientsProtocolAndChecklist.clientsChecklist.some(clientCheck => clientCheck.name === clientProtocol.name));
        const clientsMissingChecklistID = "clientsMissingChecklistID";
        const clientsMissingChecklistTitleKey = 'protocol.tab-checklist.messages.clients-missing-checklist';
        this.loadClientsMissingWarning(clientsMissingChecklist, clientsMissingChecklistID, clientsMissingChecklistTitleKey);*/
    },

    loadClientsMissingWarning(clientsMissing, clientsMissingID, titleKey){
      this.generalMessages = this.generalMessages.filter(msg => msg.id !== clientsMissingID);
      if(clientsMissing.length > 0) {
        let clientsMissingProtocolWarning = "\n";
        for(let i=0; i < clientsMissing.length; i++) {
          clientsMissingProtocolWarning += clientsMissing[i].name;
          if((i+1) < clientsMissing.length) {
            clientsMissingProtocolWarning += "\n";
          }
        }
        this.generalMessages.push({severity: 'warn', detail: 'Warn Message', content: `${this.$t(titleKey)+clientsMissingProtocolWarning}`, id: clientsMissingID});
      }
    },

    async getHtmlLetter() {
        let htmlLetter = await LetterBusiness.getHtmlLetter(this.protocolId).catch((e) => ToastMessageBusiness.showError(e.message));
        if (htmlLetter) {
            const finalLetter = await DialogService.openModal(ModalEditLetter, {originalLetter: htmlLetter});
            if(finalLetter) {
                await LetterBusiness.printLetterFromHtmlPdf(this.protocolId, finalLetter);
                //await LetterBusiness.printLetterFromHtmlWord(this.protocolId, finalLetter);
            }
        }
    },

    async sendProcess(){
      const trackingCode = await DialogService.openModal(ModalSendProcess);
      if(trackingCode){
        const response = await ProtocolBusiness.sendProcess(this.protocol.id, trackingCode);
        if(response){
          window.location.reload();
        }
      }
    },

    async cancelSendProcess(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.cancelSendProcess(this.protocol.id);
        if(response){
          window.location.reload();
        }
      }
    },

    async generateGenealogyTreeDocx() {
        EventBus.loadingModal(true);
        const fileName = "Arvore_" + this.clientsProtocol[0].protocol.mainClient.name.replaceAll(" ", "_");
        await TreeBusiness.generateGenealogyTreeDocx(this.protocolId, fileName);
        EventBus.loadingModal(false);
    },

    async budgetToProtocol(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.budgetToProtocol(this.protocol.id);
        if(response){
          window.location.reload();
        }
      }
    },

    async reactive(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.reactive(this.protocol.id);
        if(response){
          this.protocol.status = 'ACTIVE';
        }
      }
    },

  },

  beforeDestroy() {
    EventBus.$off('DELETE_CERTIFICATE');
    EventBus.$off('openModalAddChecklistProtocolPerson');
    EventBus.$off('loadChecklistProtocolPeople');
  }

}
</script>

<style scoped>

  .content{
    margin-bottom: 40px;
  }

  .footer {
    bottom: 0;
    left: 0;
    height: 50px;
    position: fixed;
    width: 100%;
  }

</style>